// Cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var el = document.querySelector('.cart-count');
      if (!el) return;
      if (cart.item_count > 0) {
        el.textContent = cart.item_count;
        el.style.display = 'inline-flex';
      } else {
        el.style.display = 'none';
      }
    });
}
document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();

  // Mobile nav
  var toggle = document.getElementById('nav-toggle');
  var close = document.getElementById('mobile-close');
  var nav = document.getElementById('mobile-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() { nav.classList.add('open'); });
  }
  if (close && nav) {
    close.addEventListener('click', function() { nav.classList.remove('open'); });
  }

  // Gallery thumbs
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var main = document.getElementById('gallery-main');
      if (main) main.src = this.dataset.full;
      document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Option buttons
  document.querySelectorAll('.option-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = this.closest('.option-values');
      group.querySelectorAll('.option-btn').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
    });
  });

  // Accordion
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var content = this.nextElementSibling;
      var isOpen = this.classList.contains('open');
      this.classList.toggle('open', !isOpen);
      if (content) content.classList.toggle('open', !isOpen);
    });
  });

  // ATC form
  var atcForm = document.getElementById('product-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('atc-btn');
      var variantInput = document.getElementById('variant-id');
      if (!variantInput) return;
      var data = { id: variantInput.value, quantity: 1 };
      if (btn) btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function() {
        updateCartCount();
        if (btn) btn.textContent = 'Added';
        setTimeout(function() { if (btn) btn.textContent = 'Add to Bag'; }, 2000);
      })
      .catch(function() { if (btn) btn.textContent = 'Add to Bag'; });
    });
  }
});
